import React, {useState, useRef, useEffect, useContext} from 'react'
import Modal from 'react-bootstrap/Modal'
import moment from 'moment'
import {ClearButton, Typeahead} from 'react-bootstrap-typeahead'
import 'react-bootstrap-typeahead/css/Typeahead.css'
import {useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import {ToastContainer, toast} from 'react-toastify'
import clsx from 'clsx'
import {default as Apiservices} from '../../../../common/index'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import {Container, Row, Col} from 'react-bootstrap'
import ReactPaginate from 'react-paginate'
import BackDrop from '../../../modules/apps/timesheetentry/ComponentBackdrop'
import EmployeePop from '../../../modules/apps/masters/modal/EmployeePop'
import {Tooltip} from '../../../modules/apps/timesheetentry/ComponentTooltip'
import ValidateContext from '../../../modules/apps/masters/commonicons/ValidateContext'

export default function OrgWeeklyComplianceReports(props: any) {
  const methods = useForm()
  const values = [true]
  const [fullscreen, setFullscreen] = useState<any>(true)
  const [show, setShow] = useState(true)
  const [Reportsdata, setReports_Data] = useState<any | []>([])
  const [consultant_type, setConsultantType] = useState('')
  const [orgList, setOrgList] = useState<any | []>([])
  const [test, setTest] = useState(null)
  const [test1, setTest1] = useState(null)
  const [DateValidation, setDateValidation] = useState(false)
  const {getValidate}: any = useContext(ValidateContext)

  const handleClose = () => {
    setFullscreen(false)
    setShow(false)
    props.cancel(false)
    props.view_open(false)
    props.setViewOpen(false)
  }
  const validationSchema = Yup.object().shape({
    first_name: Yup.string().required('First Name is required').nullable(),
  })

  type UserSubmitForm = {
    employee_type: string
    org_name: any
    select_Year: any
    project_type: any
  }
  const {
    register,
    handleSubmit,
    resetField,
    reset,
    setValue,
    getValues,
    formState: {errors},
  } = useForm<UserSubmitForm>({
    resolver: yupResolver(validationSchema),
  })
  const [showBackDrop, setShowBackDrop] = useState(false)
  const [loading, setLoading] = useState(true)
  const [flag, setFlag] = useState(false)
  const [ReportData, setReportData] = useState<any | []>([])
  const [search, setSearch] = useState('')
  const [selected, setSelected] = useState([])
  const [selectMonth, setSelectMonth] = useState<any>([])
  const [selectConsultant, setSelectConsultant] = useState([])
  const [select_consultant, setSelectconsultant] = useState<any | []>([])
  const [order5, setOrder5] = useState('ASC')
  const [order6, setOrder6] = useState('ASC')
  const [order8, setOrder8] = useState('ASC')
  const [sort, setSort] = useState<any | []>(false)
  const [country1, setCountry1] = useState<any | []>([])
  const [candidate, setCandidate] = useState<any | []>([])
  const [candidateList, setCandidateList] = useState<any | []>([])
  const BASE_MONTH_OPTIONS = [
    {label: 'January', value: '1'},
    {label: 'February', value: '2'},
    {label: 'March', value: '3'},
    {label: 'April', value: '4'},
    {label: 'May', value: '5'},
    {label: 'June', value: '6'},
    {label: 'July', value: '7'},
    {label: 'August', value: '8'},
    {label: 'September', value: '9'},
    {label: 'October', value: '10'},
    {label: 'November', value: '11'},
    {label: 'December', value: '12'},
  ]
  const [AllMonthOptions, setAllMonthOptions] = useState<any | []>(BASE_MONTH_OPTIONS)
  const [perPage, setPerPage] = useState(25)
  const [page, setPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [AllOptions, setAllOptions] = useState<any | []>([
    {
      label: 'Select All',
      value: 'All',
    },
    {
      label: 'W2',
      value: 'W2',
    },
    {
      label: 'C2C',
      value: 'C2C',
    },
    {
      label: 'Internal',
      value: 'Internal',
    },
    {
      label: '1099',
      value: '1099',
    },
    {
      label: 'Offshore',
      value: 'Offshore',
    },
  ])
  const typeaheadRef: any = useRef<HTMLInputElement>(null)
  const typeaheadRef2: any = useRef<HTMLInputElement>(null)
  const typeaheadRef3: any = useRef<HTMLInputElement>(null)
  const typeaheadRef1: any = useRef<HTMLInputElement>(null)
  const typeaheadRef4: any = useRef<HTMLInputElement>(null)

  const [BusinessUnitsList, setBusinessUnitsList] = useState<any | []>([])
  const [BusinessUnit, setBusinessUnit] = useState<any | []>([])
  const [countries1, setCountries1] = useState<any | []>([])
  const [years, setYears] = useState<any>([])
  const [selectYear, setSelectYear] = useState('')
  const [ProjectReportData, setProjectReportData] = useState<any | []>([])
  const [OrganizationReportData, setOrganizationReportData] = useState<any | []>([])
  const [OrganizationReportDataCount, setOrganizationReportDataCount] = useState<any | []>([])

  const onSubmit = async (data: UserSubmitForm) => {
    setShowBackDrop(true)
    const employeeValid: any = await Apiservices.employeeId()
    setShowBackDrop(false)
  }

  const options2: any = [
    {
      label: 'W2',
      value: 'W2',
    },
    {
      label: 'C2C',
      value: 'C2C',
    },
    {
      label: 'Internal',
      value: 'Internal',
    },
    {
      label: '1099',
      value: '1099',
    },
    {
      label: 'Offshore',
      value: 'Offshore',
    },
  ]
  const options3: any = [
    {
      label: 'January',
      value: '1',
    },
    {
      label: 'February',
      value: '2',
    },
    {
      label: 'March',
      value: '3',
    },
    {
      label: 'April',
      value: '4',
    },
    {
      label: 'May',
      value: '5',
    },
    {
      label: 'June',
      value: '6',
    },
    {
      label: 'July',
      value: '7',
    },
    {
      label: 'August',
      value: '8',
    },
    {
      label: 'September',
      value: '9',
    },
    {
      label: 'October',
      value: '10',
    },
    {
      label: 'November',
      value: '11',
    },
    {
      label: 'December',
      value: '12',
    },
  ]
  useEffect(() => {
    // handleConsultant()
    let currYr: any = new Date().getFullYear()
    setSelectYear(currYr)
    let pastYr = 2013
    while (currYr >= pastYr) {
      // setYears([...currYr]);
      years.push(currYr)
      currYr -= 1
    }
  }, [])
  useEffect(() => {
    get_business_units_list()
  }, [])
  const sorting5 = (col: any) => {
    console.log(OrganizationReportData)

    if (order5 === 'ASC') {
      const sorted = [...OrganizationReportData]?.sort((a, b) => (a[col] > b[col] ? 1 : -1))
      console.log(sorted, 'asc')

      setOrganizationReportData(sorted)
      setOrder5('DSC')
      setSort(false)
    }

    if (order5 === 'DSC') {
      console.log(OrganizationReportData)
      const sorted = [...OrganizationReportData]?.sort((a, b) => (a[col] < b[col] ? 1 : -1))

      console.log(sorted, 'dsc')

      setOrganizationReportData(sorted)

      setOrder5('ASC')
      setSort(true)
    }
  }

  const sorting6 = (col: any) => {
    if (order6 === 'ASC') {
      const sorted = [...OrganizationReportData]?.sort((a: any, b: any) => {
        const lowerA = a[col]?.replace(/\s+/g, '').toLowerCase()
        const lowerB = b[col]?.replace(/\s+/g, '').toLowerCase()
        return lowerA?.localeCompare(lowerB)
      })

      setOrganizationReportData(sorted)
      setOrder6('DSC')
      setSort(false)
    }

    if (order6 === 'DSC') {
      const sorted = [...OrganizationReportData]?.sort((a: any, b: any) => {
        const lowerA = a[col]?.replace(/\s+/g, '').toLowerCase()
        const lowerB = b[col]?.replace(/\s+/g, '').toLowerCase()
        return lowerB?.localeCompare(lowerA)
      })

      setOrganizationReportData(sorted)
      setOrder6('ASC')
      setSort(true)
    }
  }

  const sorting8 = (col: any) => {
    if (order8 === 'ASC') {
      const sorted = [...OrganizationReportData]?.sort((a, b) => a[col] - b[col])

      setOrganizationReportData(sorted)
      setOrder8('DSC')
      setSort(false)
    }

    if (order8 === 'DSC') {
      const sorted = [...OrganizationReportData]?.sort((a, b) => b[col] - a[col])
      setOrganizationReportData(sorted)
      setOrder8('ASC')
      setSort(true)
    }
  }

  const get_business_units_list = async () => {
    // const res: any = await Apiservices.get_business_units_list()
    // if (res && res.status == 200) {
    //   if (res.data.data.length > 0) {
    //     // setBusinessUnitsList(res.data.data)
    //     let obj = {name: 'Select All', value: 'All'}
    //     setBusinessUnitsList([obj, ...res.data.data])
    //   }
    // }

    let y = JSON.parse(localStorage.getItem('bu_list') || '[]')

    let n = y.filter(
      (element: any) =>
        element.roleName?.toLowerCase() == 'accounts' ||
        element.roleName?.toLowerCase() == 'approver'
      // element.roleName?.toLowerCase() == 'timesheetadmin'
    )
    let business: any = localStorage.getItem('role_Name')
    let numArray: any = business?.split(',')
    let uniqueArr: any = []

    const res: any = await Apiservices.get_business_units_list()
    if (res && res.status == 200) {
      if (res.data.data.length > 0) {
        let obj = {name: 'Select All', value: 'All'}
        if (numArray?.includes('admin') || numArray?.includes('timesheetadmin')) {
          let x = res.data.data.filter((test: any) => uniqueArr.push(test))
          setBusinessUnitsList([obj, ...uniqueArr])
        } else {
          for (let each of res.data.data) {
            for (let item of n) {
              if (each.business_unit_id == item.buId) {
                uniqueArr.push(each)
              }
            }
          }
          setBusinessUnitsList([obj, ...uniqueArr])
        }
      }
    }
  }

  const handlePageClick = (event: any) => {
    let page = event.selected
    let selected = page + 1
    setPage(selected)
    // getallprojects(mainTableData, selected, perPage)
    handleClick(selected, perPage)
  }

  const onChange = async (e: any) => {
    const {name, value} = e.target
    if (name == 'perPage') {
      setPerPage(value)
      setPage(1)
      // getallprojects(mainTableData, 1, value)
      handleClick(1, value)
    }
  }

  // const handleClick = async () => {
  const handleClick = async (page: any, perPage: any) => {
    let stat1 = selectConsultant.map((val: any) => {
      return val.value
    })
    let stat2 = stat1.filter((temp: any) => `${temp}`).join(',')

    let business1 = BusinessUnit.map((val: any) => {
      return val.business_unit_id
    })
    let business2 = business1.filter((temp: any) => `${temp}`).join(',')

    // let month1 = selectMonth.map((temp: any) => {
    //   return Number(temp.value)
    // })
    // let month12 = month1.filter((temp: any) => `${temp}`).join(',')
    let employee = select_consultant.map((value: any) => {
      return Number(value.id)
    })
    let employee1 = employee.filter((temp: any) => `${temp}`).join(',')
    let project = countries1.map((value: any) => {
      return Number(value.id)
    })
    let project1 = project.filter((temp: any) => `${temp}`).join(',')
    // let currentDate: any = new Date()
    // if (test) {
    //   setTest(test)
    // } else {
    //   setTest(currentDate)
    // }

    setShowBackDrop(true)
    setFlag(true)
    setDateValidation(true)
    if (test != null) {
      setDateValidation(false)
      if (selectMonth && selectMonth.length > 0) {
        const response1: any = await Apiservices.employee_wise_yearly_compliance_report_week_wise({
          org_id: localStorage.getItem('org_id'),
          year: test
            ? moment(test, 'ddd MMM DD YYYY').format('YYYY')
            : moment(new Date(), 'ddd MMM DD YYYY').format('YYYY'),
          employee_type: stat2 ? stat2 : '',
          business_unit_id: business2 ? business2 : '',
          month: selectMonth ? selectMonth : null,
          // pagenumber: page,
          // pagesize: Number(perPage),
        })
        setPages(Math.ceil(response1?.data?.count[0]?.count / Number(perPage)))
        setOrganizationReportDataCount(response1?.data?.count[0]?.count)
        let AllMonths = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]
        if (response1 && response1.data && response1.data.isError == false) {
          let test = response1.data.total_data // without business unit
          let AllData = [test]
          if (response1 && response1.data && response1.data.data?.length > 0) {
            let x = response1.data.data

            AllData.push(x)
          }
          let data2: any = []
          let data3: any = []
          let data4: any = []

          for (let each of AllData) {
            for (let item of each) {
              data2.push(item)
            }
          }

          for (let each of test) {
            let y = data2.filter((temp: any) => temp.week_start_date == each.week_start_date)
            data3.push(y)
          }
          for (let each of data3) {
            for (let item of each) {
              data4.push(item)
            }
          }
          setOrganizationReportData(data4)
          setProjectReportData(data4)
        }
      } else {
        const employeeResponse: any =
          await Apiservices.employee_wise_yearly_compliance_report_total({
            org_id: localStorage.getItem('org_id'),
            year: test
              ? moment(test, 'ddd MMM DD YYYY').format('YYYY')
              : moment(new Date(), 'ddd MMM DD YYYY').format('YYYY'),
            employee_type: stat2 ? stat2 : '',
            business_unit_id: business2 ? business2 : '',
            pagenumber: page,
            pagesize: Number(perPage),
          })
        setPages(Math.ceil(employeeResponse?.data?.count[0]?.count / Number(perPage)))
        setOrganizationReportDataCount(employeeResponse?.data?.count[0]?.count)

        let AllMonths = [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December',
        ]
        let finalData = []
        if (employeeResponse && employeeResponse.data && employeeResponse.data.isError == false) {
          let test = employeeResponse.data.total_data // without business unit
          let AllData = [test]

          if (employeeResponse && employeeResponse.data && employeeResponse.data.data?.length > 0) {
            for (let each of business1) {
              let x = employeeResponse.data.data.filter(
                (temp: any) => temp.business_unit_id == each
              )
              AllData.push(x)
            }
          }
          let data2: any = []
          let data3: any = []
          let data4: any = []
          for (let each of AllData) {
            for (let item of each) {
              data2.push(item)
              finalData.push(item)
            }
          }
          for (let each of AllMonths) {
            let x1 = data2?.filter((temp: any) => temp.monthName == each)
            data3.push(x1)
          }
          for (let item of data3) {
            for (let item1 of item) {
              data4.push(item1)
            }
          }
          setOrganizationReportData(data4)
          setProjectReportData(data4)
        }
      }
    }
    setShowBackDrop(false)
  }

  const ref: any = useRef<HTMLInputElement>(null)

  const resetData = async (e: any) => {
    setFlag(false)
    setDateValidation(false)
    setConsultantType('')
    setValue('employee_type', '')
    setTest(null)
    setTest1(null)
    // typeaheadRef1.current.clear()
    setSelected([])
    setSelectMonth([])
    setSelectMonth(null)
    let dataSet = {
      project_type: '',
    }
    reset(dataSet)
    typeaheadRef.current.clear()
    setSelectConsultant([])
    // typeaheadRef2.current.clear()
    setSelectconsultant([])
    // typeaheadRef3.current.clear()
    setCountries1([])
    setBusinessUnit([])
    typeaheadRef4.current.clear()

    let businessReset = BusinessUnitsList.find((item: any) => item.value == 'All')
    if (!businessReset) {
      BusinessUnitsList.unshift({
        name: 'Select All',
        value: 'All',
      })
    }
    // BusinessUnitsList.pop({
    //   name: 'Deselect All',
    //   value: 'empty',
    // })
    let businessReset1 = BusinessUnitsList.find((item: any) => item.value == 'empty')
    if (businessReset1) {
      BusinessUnitsList.splice(
        BusinessUnitsList.findIndex((item: any) => item.value == 'empty'),
        1
      )
    }

    let consultantReset = AllOptions.find((item: any) => item.value == 'All')
    if (!consultantReset) {
      AllOptions.unshift({
        label: 'Select All',
        value: 'All',
      })
    }
    // AllOptions.pop({
    //   label: 'Deselect All',
    //   value: 'empty',
    // })
    let consultantReset1 = AllOptions.find((item: any) => item.value == 'empty')
    if (consultantReset1) {
      AllOptions.splice(
        AllOptions.findIndex((item: any) => item.value == 'empty'),
        1
      )
    }
  }

  const exporthandleClick = async (e: any) => {
    setDateValidation(true)
    if (test != null) {
      setDateValidation(false)
      let stat1 = selectConsultant.map((val: any) => {
        return val.value
      })
      let stat2 = stat1.filter((temp: any) => `${temp}`).join(',')
      let business1 = BusinessUnit.map((val: any) => {
        return val.business_unit_id
      })
      let business2 = business1.filter((temp: any) => `${temp}`).join(',')
      setShowBackDrop(true)
      if (selectMonth && selectMonth.length > 0) {
        const res1: any = await Apiservices.export_employee_wise_yearly_compliance_report_week_wise(
          {
            org_id: localStorage.getItem('org_id'),
            // year: moment(test, 'ddd MMM DD YYYY').format('YYYY'),
            year: test
              ? moment(test, 'ddd MMM DD YYYY').format('YYYY')
              : moment(new Date(), 'ddd MMM DD YYYY').format('YYYY'),
            employee_type: stat2 ? stat2 : '',
            business_unit_id: business2 ? business2 : '',
            month: selectMonth ? selectMonth : null,
          }
        )

        // var link = document.createElement('a')
        // // If you don't know the name or want to use
        // // the webserver default set name = ''
        // link.setAttribute('download', 'Downloaded File')
        // link.href = res1?.data?.data?.blobUrl
        // document.body.appendChild(link)
        // link.click()
        // link.remove()
        if (res1?.data?.isError == false) {
          if (res1?.data?.data?.blobUrl) {
            getValidate(res1?.data?.data?.blobUrl, 'download')
          } else {
            toast.warn('No Records Found')
          }
        } else {
          toast.error('Something went wrong')
        }
      } else {
        const res: any = await Apiservices.export_employee_wise_yearly_compliance_report({
          org_id: localStorage.getItem('org_id'),
          // year: moment(test, 'ddd MMM DD YYYY').format('YYYY'),
          year: test
            ? moment(test, 'ddd MMM DD YYYY').format('YYYY')
            : moment(new Date(), 'ddd MMM DD YYYY').format('YYYY'),
          employee_type: stat2 ? stat2 : '',
          business_unit_id: business2 ? business2 : '',
        })

        // var link = document.createElement('a')
        // // If you don't know the name or want to use
        // // the webserver default set name = ''
        // link.setAttribute('download', 'Downloaded File')
        // link.href = res?.data?.data?.blobUrl
        // document.body.appendChild(link)
        // link.click()
        // link.remove()
        if (res?.data?.isError == false) {
          if (res?.data?.data?.blobUrl) {
            getValidate(res?.data?.data?.blobUrl, 'download')
          } else {
            toast.warn('No Records Found')
          }
        } else {
          toast.error('Something went wrong')
        }
      }
      setShowBackDrop(false)
    }
  }
  let FilteredData = ReportData?.data?.filter(
    (each: any) =>
      each?.employee_id?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.employee_type?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.full_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.joining_date?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.leaving_date?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.emp_working_hours?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.total_hours?.toLowerCase()?.includes(search?.toLowerCase()) ||
      each?.compliance_percentage?.toLowerCase()?.includes(search?.toLowerCase())
  )
  // const singleDateSelection = async (date: any) => {
  //   setTest(date)
  //   setDateValidation(false)
  // }
  const singleDateSelection = async (date: any) => {
    setTest(date)
    setDateValidation(false)
    setSelectMonth([])
    let currentYear = moment(new Date()).format('YYYY')
    let selectYear = moment(date).format('YYYY')
    if (currentYear == selectYear) {
      let currentMonth = moment(new Date()).format('M') //july
      let limitedMonths = BASE_MONTH_OPTIONS.slice(0, parseInt(currentMonth))
      setAllMonthOptions(limitedMonths)
    } else {
      setAllMonthOptions(BASE_MONTH_OPTIONS)
    }
  }
  const singleDateSelection1 = async (date: any) => {
    setTest1(date)
  }
  const handleCountries1 = async (country1: any) => {
    // if (country1 && country1.length >= 2) {
    const response: any = await Apiservices.getprojectbyname({country_name: country1})
    if (response?.data?.data !== null) {
      setCountry1(response && response.data && response.data.data ? response?.data?.data : '')
    }
    // }
  }

  const selectedCountries1 = async (state: any) => {
    setCountries1(state)
  }
  const user = (candidate: any) => {
    if (candidate === null) return ''
    else {
      let str = ''

      candidate.split(' ').forEach((ele: any, i: any) => {
        str += (i == 0 ? '' : ' ') + ele.charAt(0).toUpperCase() + ele.slice(1)
      })

      return str
    }
  }
  const handleConsultant = async (consult_Name?: any) => {
    const response: any = await Apiservices.getconsultantbyname()
    setCandidate(response?.data?.data)
  }
  const handleFilterConsultant = async (consult_Name: any) => {
    // let filteredConsultant = candidate?.filter((each: any) =>
    //   each?.full_name?.toLowerCase()?.includes(consult_Name?.toLowerCase())
    // )
    // setCandidateList(filteredConsultant)
    const response: any = await Apiservices.getconsultantbyname()
    setCandidateList(response?.data?.data)
  }

  const selectedConsultant = async (consult_name: any) => {
    setSelectconsultant(consult_name)
  }

  const handleBusinessUnit = (selected: any) => {
    // setBusinessUnit(selected)

    if (selected.length > 0) {
      for (let each of selected) {
        if (each.value == 'All') {
          let x = BusinessUnitsList.filter(
            (temp: any) => temp.value != 'All' && temp.value != 'empty'
          )
          setBusinessUnit(x)
          BusinessUnitsList.shift({
            name: 'Select All',
            value: 'All',
          })
          let abc = BusinessUnitsList.find((item: any) => item.value == 'empty')
          if (!abc) {
            BusinessUnitsList.push({
              name: 'Deselect All',
              value: 'empty',
            })
            setBusinessUnitsList(BusinessUnitsList)
          }
        } else if (each.value == 'empty') {
          setBusinessUnit([])
          let cde = BusinessUnitsList.find((item: any) => item.value == 'All')

          if (!cde) {
            BusinessUnitsList.unshift({
              name: 'Select All',
              value: 'All',
            })
            // setBusinessUnitsList(BusinessUnitsList)
          }
          BusinessUnitsList.pop({
            name: 'Deselect All',
            value: 'empty',
          })
        } else {
          setBusinessUnit(selected)
          let abc = BusinessUnitsList.find((item: any) => item.value == 'empty')
          let cde = BusinessUnitsList.find((item: any) => item.value == 'All')

          if (!abc) {
            BusinessUnitsList.push({
              name: 'Deselect All',
              value: 'empty',
            })
            setBusinessUnitsList(BusinessUnitsList)
          }
          if (!cde) {
            BusinessUnitsList.unshift({
              name: 'Select All',
              value: 'All',
            })
            setBusinessUnitsList(BusinessUnitsList)
          }

          let check_drop = selected.find((item: any) => item && item.value && item.value == 'All')
          let check_drop1 = selected.find(
            (item: any) => item && item.value && item.value == 'empty'
          )
          if (!check_drop && !check_drop1) {
            let test = BusinessUnitsList.filter(
              (id: any) => !selected.some((x: any) => x.name == id.name)
            )
            if (test.length == 2) {
              let sample = test.filter((res: any) => res.value == 'All' || res.value == 'empty')
              BusinessUnitsList.shift({
                name: 'Select All',
                value: 'All',
              })
            }
          }
        }
      }
    } else {
      setBusinessUnit(selected)
      BusinessUnitsList.pop({
        label: 'Deselect All',
        value: 'empty',
      })

      let businessReset = BusinessUnitsList.find((item: any) => item.value == 'All')
      if (!businessReset) {
        BusinessUnitsList.unshift({
          name: 'Select All',
          value: 'All',
        })
      }
    }
  }
  const handleConsultantType = (selected: any) => {
    if (selected.length > 0) {
      for (let each of selected) {
        if (each.value == 'All') {
          let x = AllOptions.filter((temp: any) => temp.value != 'All' && temp.value != 'empty')
          setSelectConsultant(x)
          AllOptions.shift({
            label: 'Select All',
            value: 'All',
          })
          let abc = AllOptions.find((item: any) => item.value == 'empty')
          if (!abc) {
            AllOptions.push({
              label: 'Deselect All',
              value: 'empty',
            })
            setAllOptions(AllOptions)
          }
        } else if (each.value == 'empty') {
          setSelectConsultant([])
          let cde = AllOptions.find((item: any) => item.value == 'All')
          if (!cde) {
            AllOptions.unshift({
              label: 'Select All',
              value: 'All',
            })
            // setAllOptions(AllOptions)
          }
          AllOptions.pop({
            label: 'Deselect All',
            value: 'empty',
          })
        } else {
          setSelectConsultant(selected)
          let abc = AllOptions.find((item: any) => item.value == 'empty')
          let cde = AllOptions.find((item: any) => item.value == 'All')
          if (!abc) {
            AllOptions.push({
              label: 'Deselect All',
              value: 'empty',
            })
            // setAllOptions(AllOptions)
          }
          if (!cde) {
            AllOptions.unshift({
              label: 'Select All',
              value: 'All',
            })
            setAllOptions(AllOptions)
          }
          let check_drop = selected.find((item: any) => item.value == 'All')
          let check_drop1 = selected.find((item: any) => item.value == 'empty')

          if (!check_drop && !check_drop1) {
            let test = AllOptions.filter(
              (id: any) => !selected.some((x: any) => x.value == id.value)
            )
            if (test.length == 2) {
              let sample = test.filter((res: any) => res.value == 'All' || res.value == 'empty')
              AllOptions.shift({
                label: 'Select All',
                value: 'All',
              })
            }
          }
        }
      }
    } else {
      setSelectConsultant(selected)
      AllOptions.pop({
        label: 'Deselect All',
        value: 'empty',
      })

      let consultantReset = AllOptions.find((item: any) => item.value == 'All')
      if (!consultantReset) {
        AllOptions.unshift({
          label: 'Select All',
          value: 'All',
        })
      }
    }
    // setSelectConsultant(selected)
  }
  return (
    <>
      <Modal show={show} fullscreen={fullscreen} onHide={() => handleClose()}>
        <Modal.Header closeButton className='p-3 bg-light'>
          <Modal.Title>Organization Compliance Report - Weekly </Modal.Title>
        </Modal.Header>
        <Modal.Body className='p-3 bg-light'>
          <div className='d-flex justify-content-between align-items-center'>
            <div> </div>
          </div>
          <form onSubmit={handleSubmit(onSubmit)}>
            <BackDrop showBackDrop={showBackDrop} />
            {loading ? (
              <>
                {' '}
                <div className='card card-custom card-flush '>
                  <div className='card-body p-2 py-3'>
                    <div className='row gy-3 align-items-center py-2'>
                      <div className='col-xs-12 col-md-3 col-lg-3'>
                        <label className='form-label fw-semibold'>Select Year *</label>
                        <DatePicker
                          selected={test}
                          onChange={(date: any) => singleDateSelection(date)}
                          placeholderText='Select Year'
                          className={clsx('form-control')}
                          maxDate={new Date()}
                          dateFormat='yyyy'
                          showYearPicker
                          // required
                        />
                        {DateValidation && (
                          <span className='error text-danger mb-0'>Year is required</span>
                        )}
                      </div>
                      <div className='col-xs-12 col-md-3 col-lg '>
                        <label className='form-label '>Select Month</label>
                        {/* <DatePicker
                          selected={test1}
                          onChange={(date: any) => singleDateSelection1(date)}
                          //   customInput={<ExampleCustomInput />}
                          placeholderText='Select Month'
                          className={clsx('form-control')}
                          dateFormat='MMM'
                          // calendarStartDay={1}
                          showMonthYearPicker
                          // required
                        /> */}

                        <select
                          className={clsx('form-select')}
                          placeholder='Select Month'
                          disabled={test ? false : true}
                          value={selectMonth}
                          {...register('project_type', {
                            required: true,
                            onChange: (e) => {
                              setSelectMonth(e.target.value)
                            },
                          })}
                          aria-label='Default select example'
                        >
                          <option value=''>Select Month</option>
                          {AllMonthOptions.map((option: any) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>

                        {/* <div className='invalid-feedback'>{errors.employee_type?.message}</div> */}
                      </div>
                      <div className='col-xs-12 col-md-3 col-lg'>
                        <label className='form-label '>Business Unit</label>
                        {/* <Typeahead
                          multiple
                          id='keep-menu-open'
                          // disabled={isView}
                          onChange={(e) => {
                            setBusinessUnit(e)
                            typeaheadRef4.current.toggleMenu()
                          }}
                          options={BusinessUnitsList}
                          ref={typeaheadRef4}
                          placeholder='Select Business Unit'
                          selected={BusinessUnit}
                          labelKey={(BusinessUnitsList: any) => BusinessUnitsList.name}
                          //   inputProps={{required: true}}
                        >
                        </Typeahead> */}

                        <Typeahead
                          multiple
                          id='keep-menu-open'
                          // disabled={isView}
                          onChange={(e) => {
                            // setBusinessUnit(e)
                            handleBusinessUnit(e)
                            typeaheadRef4.current.toggleMenu()
                          }}
                          options={BusinessUnitsList}
                          className='overFlowForTextField'
                          ref={typeaheadRef4}
                          placeholder='Select Business Unit'
                          selected={BusinessUnit}
                          labelKey={(BusinessUnitsList: any) => BusinessUnitsList.name}
                          //   inputProps={{required: true}}
                        ></Typeahead>
                        {/* <div className='invalid-feedback'>{errors.last_name?.message}</div> */}
                      </div>
                      <div className='col-xs-12 col-md-3 col-lg'>
                        <label className='form-label '>Consultant Type</label>
                        {/* <Typeahead
                          multiple
                          id='keep-menu-open'
                          onChange={(selected: any) => {
                            setSelectConsultant(selected)
                            // Keep the menu open when making multiple selections.
                            typeaheadRef.current.toggleMenu()
                          }}
                          options={options2}
                          placeholder='Select Consultant Type'
                          ref={typeaheadRef}
                          selected={selectConsultant}
                        /> */}

                        <Typeahead
                          multiple
                          id='keep-menu-open'
                          onChange={(selected: any) => {
                            handleConsultantType(selected)
                            // setSelectConsultant(selected)
                            // Keep the menu open when making multiple selections.
                            typeaheadRef.current.toggleMenu()
                          }}
                          options={AllOptions}
                          className='overFlowForTextField'
                          placeholder='Select Consultant Type'
                          ref={typeaheadRef}
                          selected={selectConsultant}
                        />
                        {/* <div className='invalid-feedback'>{errors.last_name?.message}</div> */}
                      </div>

                      <div className='col-auto pt-md-0 pt-lg-8'>
                        <button
                          className='btn btn-sm btn-primary'
                          type='submit'
                          // onClick={handleClick}
                          onClick={() => handleClick(page, perPage)}
                        >
                          Run
                        </button>
                      </div>
                      <div className='col-auto pt-md-0 pt-lg-8'>
                        <button
                          type='button'
                          className='btn btn-danger btn-sm cursor-pointer '
                          id='kt_toolbar_primary_button'
                          onClick={resetData}
                        >
                          Reset
                        </button>
                      </div>
                      <div className='col-auto pt-md-0 pt-lg-8'>
                        <button
                          // className='btn btn-icon btn-light  btn-active-color-primary btn-sm'
                          className='btn btn-light-primary   btn-sm'
                          onClick={exporthandleClick}
                        >
                          Export
                          {/* <i className='bi bi-cloud-arrow-down-fill fs-2'></i> */}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <h1>load</h1>
            )}
          </form>
          {flag == false && (
            <div className='fs-6 text-gray-500 text-transform-unset'>
              Note:Please select year, month & click on run to view week wise report.
            </div>
          )}
          {flag == true && (
            <>
              <div className='pt-3'>
                <div className='card card-custom card-flush '>
                  <div className='card-body p-3 py-3'>
                    <div className='table-responsive padding-down reportTab fullHeight'>
                      <table
                        id='kt_table_users'
                        className='table table-row-bordered table-row-gray-300 gy-4'
                      >
                        <>
                          <thead>
                            <tr className='fw-semibold fs-7 text-gray-600 text-uppercase'>
                              <th
                                onClick={() => sorting5(`localStorage.getItem('org_name')`)}
                                className='  py-4'
                              >
                                Org{' '}
                                <span>
                                  {order5 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                              </th>
                              {BusinessUnit &&
                                OrganizationReportData &&
                                OrganizationReportData.find(
                                  (temp: any) => temp.business_unit_id
                                ) && (
                                  <th
                                    onClick={() => sorting6('business_unit_name')}
                                    className='  py-4'
                                  >
                                    Business Unit{' '}
                                    <span>
                                      {order6 === 'ASC' ? (
                                        <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                      ) : (
                                        <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                      )}
                                    </span>
                                  </th>
                                )}
                              <th onClick={() => sorting5('monthName')} className='  py-4'>
                                Month{' '}
                                <span>
                                  {order5 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                              </th>
                              {selectMonth &&
                                OrganizationReportData &&
                                OrganizationReportData[0] &&
                                OrganizationReportData[0].week_start_date && (
                                  <th
                                    onClick={() => sorting5('week_start_date')}
                                    className='  py-4'
                                  >
                                    Week{' '}
                                    <span>
                                      {order5 === 'ASC' ? (
                                        <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                      ) : (
                                        <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                      )}
                                    </span>
                                  </th>
                                )}
                              <th onClick={() => sorting5('activeConsultants')} className='  py-4'>
                                Active Consultants{' '}
                                <span>
                                  {order5 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                              </th>
                              <th
                                onClick={() => sorting5('submittedConsultants')}
                                className='  py-4'
                              >
                                Submitted Consultants{' '}
                                <span>
                                  {order5 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                              </th>
                              <th onClick={() => sorting8('expectedHours')} className='  py-4'>
                                Expected Hours{' '}
                                <span>
                                  {order8 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                              </th>
                              <th onClick={() => sorting8('loggedHours')} className='  py-4'>
                                Total Hours Spent{' '}
                                <span>
                                  {order8 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                              </th>
                              <th
                                onClick={() => sorting8('compliance_percentage')}
                                className='  py-4'
                              >
                                Compliance %{' '}
                                <span>
                                  {order8 === 'ASC' ? (
                                    <i className='bi bi-chevron-down ms-1 ' role='button'></i>
                                  ) : (
                                    <i className='bi bi-chevron-up ms-1 ' role='button'></i>
                                  )}
                                </span>
                                <Tooltip text={'(Logged Hours/Expected Hours)*100'}>
                                  <span>
                                    <i className='bi bi-info-lg  fs-4 bg-light-danger rounded-circle text-gray-700'></i>
                                  </span>
                                </Tooltip>
                              </th>
                            </tr>
                          </thead>

                          <tbody>
                            {OrganizationReportData?.length > 0 ? (
                              <>
                                {OrganizationReportData?.map((each: any, index: any) => {
                                  return (
                                    <tr
                                      className='namepage text-dark fw-semibold  fs-6 text-nowrap'
                                      key={index}
                                    >
                                      <td>
                                        {!each.business_unit_name
                                          ? localStorage.getItem('org_name')
                                          : ''}
                                      </td>
                                      {BusinessUnit &&
                                        OrganizationReportData &&
                                        OrganizationReportData.find(
                                          (temp: any) => temp.business_unit_id
                                        ) && (
                                          <td>
                                            {each.business_unit_name ? each.business_unit_name : ''}
                                          </td>
                                        )}

                                      <td className=''>
                                        {each.monthName
                                          ? moment(each.monthName, 'MMMM').format('MMM')
                                          : '-'}{' '}
                                        {moment(test, 'ddd MMM DD YYYY').format('YYYY')}
                                      </td>
                                      {selectMonth && each && each.week_start_date && (
                                        <td className=''>
                                          {each.week_start_date ? each.week_start_date : '-'} -{' '}
                                          {each.week_end_date ? each.week_end_date : '-'}
                                        </td>
                                      )}
                                      <td className=''>{each.activeConsultants}</td>
                                      <td className=''>{each.submittedConsultants}</td>
                                      {/* <td className=''>
                                      {each.expectedHours
                                        ? each.expectedHours <= 9
                                          ? '0' + each.expectedHours
                                          : each.expectedHours
                                        : '00'}
                                      :{'00'}
                                    </td> */}
                                      <td className=''>
                                        {each.expectedHours
                                          ? each.expectedHours.toFixed(2)
                                          : '0.00'}
                                      </td>
                                      {/* <td className=''>
                                      <span>
                                        {each.loggedHours <= 9
                                          ? '0' + each.loggedHours
                                          : each.loggedHours}
                                        :{'00'}
                                      </span>
                                    </td> */}
                                      <td className=''>
                                        <span>
                                          {each.loggedHours ? each.loggedHours.toFixed(2) : '0.00'}
                                        </span>
                                      </td>
                                      <td className=''>{each.compliance_percentage}</td>
                                    </tr>
                                  )
                                })}
                              </>
                            ) : (
                              ''
                            )}
                          </tbody>
                        </>
                      </table>
                      {(OrganizationReportData?.length == null ||
                        OrganizationReportData?.length == 0) && (
                        <div className='text-center  fw-bold text-gray-800'>No Records found </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='d-flex flex-stack py-2'>
                {/* {OrganizationReportData?.length > 0 ? (
                  <div>
                    <Container className='p-0'>
                      <Row className='align-items-center'>
                        <Col xs='auto' className='pe-0'>
                          {' '}
                          <label className='form-label fw-semibold'>Rows Per Page</label>
                        </Col>

                        <Col>
                          <select
                            name='perPage'
                            className='form-select'
                            onChange={onChange}
                            value={perPage}
                          >
                            <option value='25'>25</option>
                            <option value='50'>50</option>
                            <option value='75'>75</option>
                            <option value='100'>100</option>
                          </select>
                        </Col>
                      </Row>
                    </Container>
                  </div>
                ) : null} */}

                <div className='pr-150'>
                  {/* {OrganizationReportData?.length > 0 ? (
                    <ReactPaginate
                      previousLabel={'<'}
                      nextLabel={'>'}
                      pageCount={pages}
                      onPageChange={handlePageClick}
                      containerClassName={'pagination justify-content-right'}
                      activeClassName={'active'}
                      breakLabel={'...'}
                      pageClassName={'page-item'}
                      pageLinkClassName={'page-link'}
                      previousClassName={'page-item'}
                      previousLinkClassName={'page-link'}
                      nextClassName={'page-item'}
                      nextLinkClassName={'page-link'}
                      breakClassName={'page-item'}
                      breakLinkClassName={'page-link'}
                    />
                  ) : null} */}
                </div>
              </div>
            </>
          )}
        </Modal.Body>
      </Modal>
    </>
  )
}
